import { render, staticRenderFns } from "./EmailBuilderPanel.vue?vue&type=template&id=22a7ee3c&scoped=true"
import script from "./EmailBuilderPanel.vue?vue&type=script&lang=ts"
export * from "./EmailBuilderPanel.vue?vue&type=script&lang=ts"
import style0 from "./EmailBuilderPanel.vue?vue&type=style&index=0&id=22a7ee3c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22a7ee3c",
  null
  
)

export default component.exports